"use client";

import axios from "axios";
import React, { useEffect } from "react";

export default function DashBoard() {
  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const headers = {
  //         "Content-Type": "application/json",
  //       };
  //       const data = {
  //         email: "tarteel@email.com",
  //         password: "Tarteel123",
  //       };

  //       const res = await axios.post("http://localhost:8080/RYZE/login", data, {
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       });

  //       console.error({ res });
  //     } catch (error) {
  //       console.error({ error });
  //     }
  //   };

  //   fetchData();
  // }, []);
  return <div>Dashboard</div>;
}
